import * as colors from 'uiComponents/constants/colors'

export const getBackgroundColor = ({
  isSale,
  isExtraSale,
  backgroundColor,
}: {
  isSale?: boolean
  isExtraSale?: boolean
  backgroundColor?: string
}): string => {
  if (isExtraSale && backgroundColor) {
    return backgroundColor
  }

  if (isSale) {
    return colors.saleColor
  }

  return colors.complementaryColor
}

export const getFontColor = ({
  isSale,
  isExtraSale,
  backgroundColor,
}: {
  isSale?: boolean
  isExtraSale?: boolean
  backgroundColor?: string
}): string => {
  if (isExtraSale && Boolean(backgroundColor)) {
    return colors.complementaryColor
  }

  if (isSale) {
    return colors.complementaryColor
  }

  return colors.primaryColor
}
